import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getAuth, patchAuth, postAuth, deleteAuth } from 'api/Utils';


//======================================
// Affiliates
//======================================
function pathAffiliates() {
  return `affiliates`;
}

export function patchAffiliates(successCallback, errorCallback, data) {
  patchAuth({
    "path": pathAffiliates(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function getViewAffiliateProgram(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/affiliate-program`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

//======================================
// Partners
//======================================
function pathPartners() {
  return `partners`;
}

export function patchPartners(successCallback, errorCallback, data) {
  patchAuth({
    "path": pathPartners(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function getViewPartnerOverview(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/partner-overview`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewPartnerMetrics(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/partner-metrics`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


export function getViewPartnerDetailsShforms(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/partner-details-shforms`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


//======================================
// Commissions
//======================================
export function getViewManagePartnerCommissions(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-partner-commissions`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}



//======================================
// Deals
//======================================
export function getViewManagePartnerDeals(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-partner-deals`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


export function getViewPartnerDealRedemptionShforms(successCallback, errorCallback, dealId, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/partner-deal-redemption-shforms/${dealId}`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


//======================================
// Payouts
//======================================
export function getViewManagePartnerPayouts(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-partner-payouts`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


//======================================
// Referrals
//======================================
export function getViewManageAffiliateReferrals(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-affiliate-referrals`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


//======================================
// Coupons
//======================================
function pathCoupons(couponId=null) {
  if (couponId) {
      return `coupons/${couponId}`;
  } else {
      return `coupons`;
  }
}

export function createCoupons(successCallback, errorCallback, data) {
  postAuth({
    "path": pathCoupons(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchCoupons(successCallback, errorCallback, data, couponId) {
  patchAuth({
    "path": pathCoupons(couponId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteCoupons(successCallback, errorCallback, couponId) {
  deleteAuth({
    "path": pathCoupons(couponId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewManageAffiliateCoupons(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-affiliate-coupons`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


//======================================
// Agencies
//======================================
function pathAgencies(agencyId=null) {
  if (agencyId) {
      return `agencies/${agencyId}`;
  } else {
      return `agencies`;
  }
}

export function createAgencies(successCallback, errorCallback, data) {
  postAuth({
    "path": pathAgencies(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}


export function patchAgencies(successCallback, errorCallback, data, agencyId) {
  patchAuth({
    "path": pathAgencies(agencyId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteAgencies(successCallback, errorCallback, agencyId) {
  deleteAuth({
    "path": pathAgencies(agencyId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathViewAgencyShforms() {
  return `view/agency-shforms`;
}

export function getViewAgencyShforms(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewAgencyShforms(), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


export const URL_AGENCIES_LOGO_MEDIA = `/${constants.API_VERSION}/agencies/logo-media`;
export const URL_AGENCIES_TESTIMONIAL_LOGO_MEDIA = `/${constants.API_VERSION}/agencies/testimonial-logo-media`;
export const URL_AGENCIES_SCREENSHOT_MEDIA = `/${constants.API_VERSION}/agencies/screenshot-media`;

